import { concat, differenceWith, isEmpty, isEqual } from "lodash";
import { postUserLog } from "../../actions/common";

export const postLogForGridOperations = (
  gridRef,
  gridEvent,
  siteUId,
  tierId,
  lastVisibleColumns,
  setLastVisibleColumns
) => {
  const { name, fullName, value } = gridEvent;

  if (
    name === "columns" &&
    !isEmpty(value) &&
    ["filterType", "filterValue", "filterValues"].includes(
      fullName.split(".")[1]
    )
  ) {
    const visibleColumns = gridRef.current.instance.getVisibleColumns();

    // Get Column name from caption key if available. else get datafield value
    const colName = visibleColumns.filter((col) =>
      isEqual(col.filterValues ? col.filterValues : col.filterValue, value)
    )[0]?.caption
      ? visibleColumns.filter((col) =>
          isEqual(col.filterValues ? col.filterValues : col.filterValue, value)
        )[0]?.caption
      : visibleColumns.filter((col) =>
          isEqual(col.filterValues ? col.filterValues : col.filterValue, value)
        )[0]?.dataField;

    // Searched Individual column using column search bar
    if (
      fullName.split(".")[1] === "filterValue" &&
      typeof value === "string" &&
      !isEmpty(colName)
    ) {
      postUserLog({
        event: "Material Configuration Search",
        data: {
          action: `${colName} : ${value} searched`,
          module: "Settings",
          section: "Manage Tier",
          siteUId,
          widget: "",
          tierId: String(tierId),
        },
      });
    }

    // filtered Individual column
    if (
      fullName.split(".")[1] === "filterValues" &&
      typeof value === "object" &&
      !isEmpty(colName)
    ) {
      value.map((filteredValue) => {
        postUserLog({
          event: "Material Configuration Filter",
          data: {
            action: `${filteredValue} filter selection`,
            module: "Settings",
            section: "Manage Tier",
            siteUId,
            widget: "",
            tierId: String(tierId),
          },
        });
      });
      postUserLog({
        event: "Material Configuration Filter",
        data: {
          action: `${colName} filtered`,
          module: "Settings",
          section: "Manage Tier",
          siteUId,
          widget: "",
          tierId: String(tierId),
        },
      });
    }

    // Searched Individual column using column search bar
    if (
      fullName.split(".")[1] === "filterValue" &&
      typeof value === "string" &&
      !isEmpty(colName)
    ) {
      postUserLog({
        event: "Material Configuration Search",
        data: {
          action: `${colName} : ${value} searched`,
          module: "Settings",
          section: "Manage Tier",
          siteUId,
          widget: "",
          tierId: String(tierId),
        },
      });
    }
  }

  if (fullName.split(".")[1] === "visible") {
    const visibleColumns = gridRef.current.instance.getVisibleColumns();

    const findDifference = (arr1, arr2, key) => {
      const comparator = (obj1, obj2) => obj1[key] === obj2[key];

      const diffArray1 = differenceWith(arr1, arr2, comparator);
      const diffArray2 = differenceWith(arr2, arr1, comparator);
      const difference = concat(diffArray1, diffArray2);

      return difference;
    };

    /*
      -----Approach 1-----
      If "value" === true 
        Then column is added -> we can get the current visible column and check with index to know which is added.
      If "value" === false 
        Then column is removed -> we should check previous visible column and check same index to know which col is removed.
        because current visible index will be updated.
      -----Approach 2-----
      First get the difference of column name in previous Visible columns array vs current visible columns array.
      Then 
      if "value" is true then column added.
      if "value" is false then column removed  
      */
    /* Some cases are failing with Approach 1 */

    const differenceColumn = findDifference(
      visibleColumns,
      lastVisibleColumns,
      "dataField"
    );

    if (value === true && differenceColumn.length > 0) {
      // Col Added
      postUserLog({
        event: "Material Configuration Column Chooser",
        data: {
          action: `${
            differenceColumn[0]?.caption
              ? differenceColumn[0]?.caption
              : differenceColumn[0]?.dataField
          } added to the grid `,
          module: "Settings",
          section: "Manage Tier",
          siteUId,
          tierId: String(tierId),
          widget: "",
        },
      });
    } else if (value === false && differenceColumn.length > 0) {
      // Col Removed
      postUserLog({
        event: "Material Configuration Column Chooser",
        data: {
          action: `${
            differenceColumn[0]?.caption
              ? differenceColumn[0]?.caption
              : differenceColumn[0]?.dataField
          } removed from the grid `,
          module: "Settings",
          section: "Manage Tier",
          siteUId,
          tierId: String(tierId),
          widget: "",
        },
      });
    }
    setLastVisibleColumns(visibleColumns);
  }

  //   Log For Grid Search
  if (name === "searchPanel" && !isEmpty(value)) {
    postUserLog({
      event: "Material Configuration Search",
      data: {
        action: `${value} searched in grid`,
        module: "Settings",
        section: "Manage Tier",
        siteUId,
        tierId: String(tierId),
        widget: "",
      },
    });
  }
  // Page number changing log
  if (name === "paging" && fullName.split(".")[1] === "pageIndex") {
    postUserLog({
      event: "Material Configuration View",
      data: {
        action: `Material List Page ${value + 1} clicked`,
        module: "Settings",
        section: "Manage Tier",
        siteUId,
        tierId: String(tierId),
        widget: "",
      },
    });
  }
  // Page size showing log
  if (name === "paging" && fullName.split(".")[1] === "pageSize") {
    postUserLog({
      event: "Material Configuration View",
      data: {
        action: `Material List expanded to ${value} items`,
        module: "Settings",
        section: "Manage Tier",
        siteUId,
        tierId: String(tierId),
        widget: "",
      },
    });
  }
};
